// import { get } from 'lodash';

export default {
  getLatestMessageEvt: (state) => state.latestMessageEvent || {},
  getLatestErrorUID: (state) => state.latestMessageEvent.errorUID,
  getFormErrors: (state) => state.latestMessageEvent.formErrors || {},
};
